<template>
    <div>

        <b-pagination
            v-on:input="changePage"
            v-model="page"
            :total-rows="rows"
            :per-page="perPage">
        </b-pagination>

    </div>
</template>

<script>
    // It's just a wrapper for Vue-Bootstrap paginator
    export default {
        props: {
            page: {
                required: true,
            },
            rows: {
                required: true,
            },
            perPage: {
                required: true,
            }
        },
    }
</script>
